import { Tag } from '@ads/components-react';
import type { ComponentType, ReactNode, SVGProps } from 'react';

/** Props de `PlanSectionCard`. */
export interface PlanSectionCardProps {
  /** Título da seção. */
  readonly title: string;
  /** Ícone do cabeçalho. */
  readonly icon: ComponentType<SVGProps<SVGSVGElement>>;
  /** Rótulo de badge — usado para marcar seções somente leitura. */
  readonly badge?: string | undefined;
  /** Conteúdo à direita do título (botão de ação ou interruptor). */
  readonly headerSlot?: ReactNode | undefined;
  /** Corpo da seção. */
  readonly children: ReactNode;
}

/**
 * Casca de uma seção do formulário de edição de plano.
 *
 * Existe como componente porque o mesmo cabeçalho com hairline inferior se
 * repete em oito seções entre as três abas. O `headerSlot` é o que permite que
 * "Descontos" ponha um botão e uma seção condicional ponha um interruptor no
 * mesmo lugar, sem duas variantes de card.
 */
export function PlanSectionCard({
  title,
  icon: Icon,
  badge,
  headerSlot,
  children,
}: PlanSectionCardProps) {
  return (
    <section className="flex flex-col rounded-sm border-hairline border-ctx-layout-border bg-ctx-layout-surface">
      <header className="flex items-center gap-mini border-b-hairline border-ctx-layout-border px-xxs py-micro">
        <span className="flex flex-1 items-center gap-nano">
          <Icon className="h-mini w-mini shrink-0 text-ctx-content-placeholder" />
          <h2 className="ts-heading-xs text-ctx-content-title">{title}</h2>
        </span>
        {badge ? (
          <Tag label={badge} size="sm" status="default" custom={{ text: 'text-nowrap' }} />
        ) : null}
        {headerSlot}
      </header>
      <div className="flex flex-col gap-xxxs px-xxs py-xxxs">{children}</div>
    </section>
  );
}
